module.exports = __webpack_public_path__ + "img/Categories_bg_04.4aeb4616.jpg";